import "./VendorCard.css";

import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Image, Button, Modal } from "react-bootstrap";
import { WidgetContext } from "../../../../../context/WidgetContext";
import ViewPort from "../../../../../_helpers/Enums/ViewPortEnum";
import { isStringEmpty } from "../../../../../_helpers/Functions";

interface props {
  vendor: any;
}

const VendorCard: React.FC<props> = (props) => {
  const { viewPortBreakPoint, style, /* brandId */brand, brandSettings } = useContext(WidgetContext);
  const brandSetting = brandSettings.find((s: any) => s.brandId === brand?.brandId);

  const { vendor } = props;

  const [errorsImg, setErrorsImg] = useState<string | undefined>();

  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";
  const vendorImageUrl = errorsImg ? errorsImg : (vendor.description ?
    (vendor.description.vendorDescriptionImages.length > 0 ?
      ((vendor.description.vendorDescriptionImages[0].vendorImageUrl != undefined && vendor.description.vendorDescriptionImages[0].vendorImageUrl.length > 0) ? vendor.description.vendorDescriptionImages[0].vendorImageUrl
        : placeholderImgUrl)
      : placeholderImgUrl)
    : placeholderImgUrl);

  return (
    <React.Fragment>

      {/* Desktop Simple View */}
      {viewPortBreakPoint >= ViewPort.lg && (
        <Row className="mobile-card-container">
          <Col xs={12}>

            <Row className="d-flex lodging-card">
              <Col xs={6}>
                <div className="w-100">
                  <Image
                    className="d-flex simple-lodging-image"
                    src={vendorImageUrl}
                    onError={() => setErrorsImg(placeholderImgUrl)}
                    fluid
                  />
                </div>
              </Col>

              <Col className="pr-2 pb-2 d-flex flex-column" xs={6}>
                <div className="align-items-center">
                  <h4 className="font-weight-bold text-center mt-2" style={{ color: style.fontColor }}>
                    {vendor.vendorName}
                  </h4>
                </div>
                <div className="justify-content-start">
                  {vendor.vendorUnits.map((u: any, index: number) => (
                    <>
                      <p className="m-0 p-0 font-weight-bold">{u.unitName}</p>
                      {!isStringEmpty(u.unitDescription) && (
                        <p className="m-0 p-0 pl-2">{u.unitDescription}</p>
                      )}

                      {index < vendor.vendorUnits.length - 1 && (
                        <hr />
                      )}
                    </>
                  ))}
                </div>
              </Col>
            </Row>

          </Col>
        </Row>
      )}

      {/* Mobile Simple View */}
      {viewPortBreakPoint < ViewPort.lg && (
        <Row className="simple-card-container mobile-card-border">
          <Col xs={12} className="pb-3 d-flex flex-column justify-content-between align-items-center">
            <div className="text-center">
              <h5 className="font-weight-bold text-center" style={{ color: style.fontColor }}>
                {vendor.vendorName}
              </h5>
              {/* <p className="font-italic font weight-light" style={{ color: "grey" }}>Awesome place to be!</p> */}
            </div>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
}

export default VendorCard;